
import "../sass/styles.scss";

import Header from './modules/header';
import Side from './modules/side';
import Tab from './modules/tab';
import Top from './pages/top';
import $ from "jquery";
import { gsap,Power2,TimelineLite } from "gsap";
// import Swiper from 'swiper';
// import { Navigation, Scrollbar } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/scrollbar';

class App {
  private loading : HTMLElement;
	constructor() {
    let header = new Header();
    let side = new Side();
    let tab = new Tab();
    let top = new Top();
    // Swiper.use([Navigation, Scrollbar]);
    this.loading = document.querySelector('.loading') as HTMLElement;
		document.addEventListener("DOMContentLoaded", (() => {
      setTimeout(() => {
        // this.loadingInit();
        // this.routes();
        // this.accordion();

        // this.sample();

        if(top.element){
          top.init();
        }
        tab.init();
      }, 500);
		}));
  }

  sample (){

    const svgLine = document.querySelector('#svg-line') as SVGPathElement;
    const pathLength = svgLine.getTotalLength();
    const pathData = svgLine.getAttribute('d') as string;
    // const pathArray = pathData.split(',');
    const pathArray = pathData.split(',').map(str => {
      return str;
    });
    // const pathArray = pathData.split(',').map(str => {
    //   const [x, y] = str.split(',').map(Number);
    //   return {x, y};
    // });
    // console.log(pathData);
    // console.log(pathArray);


    pathArray.forEach(point => {
      if(isNaN(Number(point))){
        console.log(point+' : '+Number(point)+1);
      }
    });

    const shakeAmount = 5;

  //   gsap.to(pathArray, {
  //     duration: 1,
  //     repeat: -1,
  //     yoyo: true,
  //     onUpdate: () => {
  //       pathArray.forEach(point => {
  //         point.y += Math.random() * shakeAmount - shakeAmount / 2;
  //         point.x += Math.random() * shakeAmount - shakeAmount / 2;
  //       });
  //       const pathData = pathArray.reduce((str, point, i) => {
  //         if (i === 0) return `M${point.x},${point.y}`;
  //         return `${str} L${point.x},${point.y}`;
  //       }, '');
  //       svgLine.setAttribute('d', pathData);
  //     }
  //   });
  }



  // loadingInit (){
  //   if(this.loading) {
  //     var logobase = document.querySelector('.logobase') as HTMLElement;
  //     var body = document.querySelector('body') as HTMLElement;
  //     logobase.classList.add("loadstart");
  //     gsap.to(".loading", {
  //       duration: 1.2,
  //       delay: 0.4,
  //       autoAlpha: 0,
  //       ease: Power2.easeInOut,
  //       onComplete: function() {
  //         console.log("w");
  //         body.classList.remove("nowloading");
  //       }
  //     })
  //   }
  // }

	// routes (){
  //   console.log('routess');
  //   const swiper = new Swiper('.swiper', {
  //     modules: [Navigation, Scrollbar],
  //     // ページネーションを設置した場合は下記を記述

  //     loop: false,
  //     centeredSlides: false,
  //     slidesPerView: 'auto',
  //     spaceBetween: 30,
  //     speed: 600,
  //     // pagination: {
  //     //   el: '.swiper-pagination',
  //     // },

  //     // ナビゲーションを設置した場合は下記を記述
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev',
  //     },

  //     // スクロールバーを設置した場合は下記を記述
  //     scrollbar: {
  //       el: '.swiper-scrollbar',
  //       hide: false,
  //       dragSize: 40,
  //       draggable: true
  //     },
  //   });
  // }

	// accordion (){

  //   $('.js-acc-nav').on('click', function(e) {
  //       e.preventDefault();
  //       var num = $('.js-acc-nav').index(this);
  //       $(this).toggleClass('active');
  //       $('.js-acc-content').eq(num).slideToggle();
  //   });

  // }

}
new App();
